interface FormValues {
  [key: string]: string;
}
export const contactInitalValues: FormValues = {
  Type: "Enquiry",
  ProductID: "",
  Name: "",
  EmailID: "",
  PhoneNo: "",
  Location: "",
  Message: " ",
  SourceUrl: "",
};

export const reviewInitalValues :FormValues ={
  Name: "",
  Message: "",
  EmailID: "",
  PhoneNo: "",
  RatingValue: "4",
}